














import { Component, Vue } from 'vue-property-decorator'
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { UserState } from '@/types'

@Component({
  components: {
    AppHeaderDropdown
  },
  props: {
    user: {
      type: Object,
      default: function (): UserState {
        return {
          id: 0,
          name: '',
          email: '',
          updatedAt: '',
          isLoggedIn: false
        }
      }
    }
  }
})
export default class DefaultHeaderDropdownAccnt extends Vue {
  // data
  itemsCount: number = 42
}
